import * as THREE from 'three';
import { useGameStore } from '@/stores/gameStore.ts';

export class MapBlackHole {
  private readonly circle: THREE.Mesh;
  private readonly circle2: THREE.Mesh;
  private readonly scene: THREE.Scene;
  private readonly geometry1: THREE.CircleGeometry;
  private readonly geometry2: THREE.CircleGeometry;
  private readonly material1: THREE.MeshBasicMaterial;
  private readonly material2: THREE.MeshBasicMaterial;
  private readonly texture: THREE.Texture;
  private readonly rotationSpeed = 0.03; // Radians per second (was 0.0005 per frame at ~60fps)

  public constructor(scene: THREE.Scene) {
    this.scene = scene;
    const gameStore = useGameStore();

    // Geometry and Material
    this.geometry1 = new THREE.CircleGeometry(64, 64);
    const textureLoader = new THREE.TextureLoader();
    this.texture = textureLoader.load(gameStore.cdnUrl + 'images/map/blackhole_orange.webp');

    this.material1 = new THREE.MeshBasicMaterial({
      map: this.texture,
      transparent: true,
      opacity: 0.5,
      color: new THREE.Color(1, 0.5, 0.5),
    });

    this.material1.needsUpdate = true;

    this.circle = new THREE.Mesh(this.geometry1, this.material1);
    this.circle.position.set(gameStore.galaxyTileGridSize/2, gameStore.galaxyTileGridSize/2, -0.1);
    scene.add(this.circle);

    // Draw a black circle in the same location
    this.geometry2 = new THREE.CircleGeometry(38, 64);
    this.material2 = new THREE.MeshBasicMaterial({
      color: 0x000000,
    });
    this.circle2 = new THREE.Mesh(this.geometry2, this.material2);
    this.circle2.position.set(gameStore.galaxyTileGridSize/2, gameStore.galaxyTileGridSize/2, 0);
    this.circle2.name = "blackHole";
    scene.add(this.circle2);
  }

  /**
   * Update the black hole rotation based on delta time
   * Called from the main render loop
   */
  public update(delta: number): void {
    this.circle.rotation.z -= this.rotationSpeed * delta;
  }

  /**
   * Dispose of all Three.js resources
   */
  public dispose(): void {
    this.scene.remove(this.circle);
    this.scene.remove(this.circle2);

    this.geometry1.dispose();
    this.geometry2.dispose();
    this.material1.dispose();
    this.material2.dispose();
    this.texture.dispose();
  }
}
